import { render, staticRenderFns } from "./DashboardShortcut.vue?vue&type=template&id=17485357"
import script from "./DashboardShortcut.vue?vue&type=script&lang=js"
export * from "./DashboardShortcut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports